import React from "react";
import TablaGruposProductos from "js/pages/Admin/Programa/Campana/GruposProductos/Tabla";

function GruposProductos(props) {
  return <TablaGruposProductos {...props} />;
}

export default GruposProductos;
